const customFieldsLang = {

}

export default {
  customFields: customFieldsLang
}
